import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop({children}) {
  const { pathname } = useLocation();
  
  useEffect(() => {
    const approvedPaths = ['/style','/personal','/benefits'];
    
    const pathCheck = (pathname, approvedPaths) => {
      return _.some(approvedPaths, (item) => _.includes(pathname.toLowerCase(), item));
    }

    const shouldScrollToTop = pathCheck(pathname, approvedPaths);

    if (shouldScrollToTop) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return <>{children}</>;
}